import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const { clear } = useCart();
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sid) {
      setState("error");
      return undefined;
    }
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const res = await api.get(`/payments/status/${sid}`);
        if (res.data?.payment_status === "paid") {
          setState("paid");
          clear();
          return;
        }
        if (["expired", "failed"].includes(res.data?.status)) {
          setState("error");
          return;
        }
      } catch {
        /* keep polling */
      }
      tries += 1;
      if (tries < 10) timer = setTimeout(poll, 2000);
      else setState("pending");
    };
    poll();
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sid]);

  return (
    <main data-testid="payment-success-page" className="grid min-h-screen place-items-center bg-obsidian px-5 pt-20 text-center">
      <div className="max-w-xl">
        {state === "checking" && <Loader2 className="mx-auto h-12 w-12 animate-spin text-volt" />}
        {state === "paid" && <CheckCircle2 className="mx-auto h-14 w-14 text-volt" />}
        {(state === "error" || state === "pending") && <XCircle className="mx-auto h-14 w-14 text-rescue" />}
        <h1 data-testid="payment-status-title" className="mt-6 font-display text-6xl md:text-7xl font-black uppercase leading-none">
          {state === "paid" ? "Locked & Loaded." : state === "checking" ? "Confirming…" : state === "pending" ? "Still processing" : "Payment not confirmed"}
        </h1>
        <p className="mt-5 text-zinc-300">
          {state === "paid" ? "Your order is confirmed. A receipt is on its way to your inbox." : "If you were charged, contact us and we'll sort it out."}
        </p>
        <Link to="/" data-testid="payment-home-link" className="btn-volt mt-10 inline-flex h-14 items-center px-8 font-mono text-sm font-bold uppercase tracking-widest"><span>Back to BAMF</span></Link>
      </div>
    </main>
  );
}

export function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="grid min-h-screen place-items-center bg-obsidian px-5 pt-20 text-center">
      <div>
        <h1 className="font-display text-6xl md:text-7xl font-black uppercase">Checkout cancelled</h1>
        <p className="mt-4 text-zinc-300">Your cart is saved. Come back when you're ready.</p>
        <Link to="/" data-testid="payment-cancel-home-link" className="btn-volt mt-10 inline-flex h-14 items-center px-8 font-mono text-sm font-bold uppercase tracking-widest"><span>Back to BAMF</span></Link>
      </div>
    </main>
  );
}
